import { inject } from 'vue'

import { FORM_ITEM_INJECTION_KEY } from '@fondof-ui/components/form/FormItem.vue'
import type { FormItemContext } from '@fondof-ui/components/form/types'
import {
  FieldContextKey,
  useFieldError,
  useIsFieldDirty,
  useIsFieldTouched,
  useIsFieldValid,
} from 'vee-validate'

export const useFormField = () => {
  const fieldContext = inject(FieldContextKey)
  const fieldItemContext = inject<FormItemContext>(FORM_ITEM_INJECTION_KEY)

  const fieldState = {
    valid: useIsFieldValid(),
    isDirty: useIsFieldDirty(),
    isTouched: useIsFieldTouched(),
    error: useFieldError(),
  }

  if (!fieldContext) {
    throw new Error('useFormField should be used within <FormField>')
  }

  if (!fieldItemContext) {
    throw new Error('useFormField should be used within <FormItem>')
  }

  const { name } = fieldContext
  const { id } = fieldItemContext

  return {
    name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formWarningId: `${id}-form-item-warning`,
    formMessageId: `${id}-form-item-message`,
    formSuccessId: `${id}-form-item-success`,
    ...fieldState,
    ...fieldItemContext,
  }
}
